export class InformationResultDto {
  item: string;
  information: string;
  sequence: number = 0;
}
